import { render, staticRenderFns } from "./DataSelectPage.vue?vue&type=template&id=7d6e7066&"
import script from "./DataSelectPage.vue?vue&type=script&lang=js&"
export * from "./DataSelectPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports